__turbopack_context__.v({
  "item": "side-nav-link-module__Y2SGKa__item",
  "link": "side-nav-link-module__Y2SGKa__link",
  "linkActive": "side-nav-link-module__Y2SGKa__linkActive",
});
